import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { useUniverse } from 'src/features/common/universe/hooks/use-universe';

export const useMeta = (page: string, interpolation: Record<string, string>) => {
    const { t } = useTranslation(['meta']);
    const { isUniverse } = useUniverse();

    return useMemo(() => {
        const project = isUniverse ? 'universe' : 'site';

        return {
            title: t(`meta.${project}.${page}.title`, { ns: 'meta', ...interpolation }),
            description: t(`meta.${project}.${page}.description`, { ns: 'meta', ...interpolation }),
        };
    }, [interpolation, isUniverse, page, t]);
};
